import React from 'react';

import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { formatDateSlashWithTime } from '~/services/TimeService';

import RelatedListCard from '../RelatedListCard';
import { accountPath } from '../accountRelatedModel';
import { useAccountOfferId } from '../useAccountOfferId';
import { useAccountRelatedPreview } from '../useAccountRelatedRows';

import { toAccountNoteAttachment } from './toAccountNoteAttachment';

interface Props {
  accountId: string;
}

export default function AccountNotesAttachmentsCard({ accountId }: Props) {
  const offerId = useAccountOfferId();
  const {
    count,
    error,
    isLoading,
    rows: notesAttachments,
  } = useAccountRelatedPreview(accountId, 'notes_attachments', toAccountNoteAttachment);

  return (
    <RelatedListCard
      count={count}
      error={error}
      icon={<InsertDriveFileIcon color="action" />}
      isLoading={isLoading}
      title="Notes & Attachments"
      viewAllTo={accountPath(accountId, offerId, '/notes-attachments')}
    >
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: 200 }}>Title</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Last Modified</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notesAttachments.map((item) => (
              <TableRow key={item.id} hover>
                <TableCell>{item.title}</TableCell>
                <TableCell>{item.type}</TableCell>
                <TableCell>{item.lastModifiedDate ? formatDateSlashWithTime(item.lastModifiedDate) : '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </RelatedListCard>
  );
}
